import React from "react";
import { config } from "../../config";
import Header from "../../components/flights/Header";

function TermsConditions() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold mb-8">Terms & Conditions</h1>

          <div className="bg-white rounded-lg shadow-sm p-8 space-y-6">
            <section>
              <p className="text-gray-600 mb-4">
                Last updated: {new Date().toLocaleDateString()}
              </p>
              <p className="text-gray-600 leading-relaxed">
                Please read these Terms and Conditions carefully before using
                the {config.flightSiteName} website. Your access to and use of the
                service is conditioned on your acceptance of and compliance with
                these terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Booking Terms</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold mb-2">Reservations</h3>
                  <p className="text-gray-600">
                    When you make a booking through our platform, you agree to
                    provide accurate and complete information. All bookings are
                    subject to availability and confirmation.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Pricing</h3>
                  <p className="text-gray-600">
                    All prices are displayed in the selected currency and
                    include applicable taxes and fees. Additional airline fees
                    for baggage or other services may apply.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Payment Terms</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Full payment is required to confirm your booking</li>
                <li>
                  We accept major credit cards and selected payment methods
                </li>
                <li>All payments are processed securely</li>
                <li>Currency conversion rates are indicative only</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">
                Cancellation Policy
              </h2>
              <div className="bg-gray-50 p-4 rounded-lg space-y-4">
                <p className="text-gray-600">
                  Cancellation policies vary depending on the airline and fare
                  type selected. Please review the specific terms before
                  completing your booking.
                </p>
                <p className="text-gray-600">
                  Refunds, when applicable, will be processed according to the
                  airline's policy and may be subject to administrative fees.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">
                User Responsibilities
              </h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Account Security</h3>
                  <p className="text-gray-600">
                    You are responsible for maintaining the security of your
                    account credentials.
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Accurate Information</h3>
                  <p className="text-gray-600">
                    You must provide accurate and complete information for all
                    bookings.
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Travel Documents</h3>
                  <p className="text-gray-600">
                    You are responsible for ensuring you have valid travel
                    documents.
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Compliance</h3>
                  <p className="text-gray-600">
                    You must comply with all applicable laws and regulations.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">
                Limitation of Liability
              </h2>
              <p className="text-gray-600 leading-relaxed">
                {config.flightSiteName} acts as an intermediary between you and the
                airlines. We are not liable for any direct or indirect damages
                arising from the use of our services or third-party services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">
                Contact Information
              </h2>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600">{config.companyInfo.name}</p>
                <p className="text-gray-600">Email: legal@example.com</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsConditions;
